import Component from "./components";
export default {
    props: {
        modelValue: {
            type: [
                Array,
                String,
                Object
            ],
            default: ()=>[]
        }
    },
    components: {
        ...Component
    },
    data () {
        return {
            visible: false,
            url: [],
            selectComponents: "Offline",
            data: [
                {
                    label: '实体商品',
                    components: "Offline"
                },
                {
                    label: '套餐商品',
                    components: "Cate"
                },
                {
                    label: '课程商品',
                    components: "Goods"
                }
            ],
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        };
    },
    watch: {
        modelValue: {
            handler (newVal) {
                if (Array.isArray(newVal)) {
                    this.url = newVal;
                } else if (newVal) {
                    this.url = [
                        newVal
                    ];
                } else {
                    this.url = [];
                }
            },
            immediate: true,
            deep: true
        },
        url (val) {
            this.$emit('update:modelValue', val);
        }
    },
    methods: {
        handleNodeClick (data) {
            if (!data.components) return;
            this.selectComponents = data.components;
        // 切换分类时不清空 url，保留其他分类的选中项
        },
        open () {
            this.visible = true;
            // 打开弹窗时，初始化 url 为当前已选中的数据
            if (Array.isArray(this.modelValue)) {
                this.url = [
                    ...this.modelValue
                ];
            } else if (this.modelValue) {
                this.url = [
                    this.modelValue
                ];
            } else {
                this.url = [];
            }
            return this;
        }
    }
};
